import nodeID from '@/mixins/nodeID'

export default {
  mixins: [nodeID],

  methods: {
    // fromType: sources, sinks, functions
    goToInstallPluginPage(fromType, pluginName) {
      this.$router.push({
        name: 'extension',
        params: {
          id: this.nodeID,
        },
        query: {
          fromPageType: fromType,
        },
      })
      const installInfo = {
        fromType,
        pluginName,
      }
      sessionStorage.setItem('installInfo', JSON.stringify(installInfo))
    },
  },
}
